"use client";

type AIReadinessEvent =
  | "aicheck_started"
  | "aicheck_question_answered"
  | "aicheck_question_navigated"
  | "aicheck_completed"
  | "aicheck_email_field_interaction"
  | "aicheck_email_submitted"
  | "aicheck_pdf_downloaded"
  | "aicheck_share_clicked"
  | "aicheck_restarted"
  | "aicheck_dropoff";

interface TrackingPayload {
  event: AIReadinessEvent;
  [key: string]: unknown;
}

function hasAnalyticsConsent(): boolean {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("cookie-consent") === "all";
}

export function trackEvent(payload: TrackingPayload): void {
  if (!hasAnalyticsConsent()) return;
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
